/**
 * Common types for the cookie package
 */

/**
 * Cookie options for setting cookies
 */
export interface CookieOptions {
  expires?: Date | number
  path?: string
  domain?: string
  secure?: boolean
  sameSite?: 'Strict' | 'Lax' | 'None'
}

/**
 * Options for deleting cookies
 */
export interface DeleteCookieOptions {
  path?: string
  domain?: string
}

/**
 * OneTrust consent category preferences
 */
export interface OneTrustConsentPreferences {
  categoryPreferences: Record<string, boolean>
}

/**
 * OneTrust consent categories
 */
export enum OneTrustCategories {
  NECESSARY = 'C0001',
  ANALYTICS = 'C0002',
  FUNCTIONAL = 'C0003',
  ADVERTISING = 'C0004',
}
